import Vue from "vue";
import JWT from "jsonwebtoken";
import User from "../../classes/User";
import i18n from "../../i18n";
import router from "../../router";

const state = {
    user: new User(),
};

const getters = {
    user(state) {
        return state.user;
    },
    email(state) {
        return state.user.email;
    },
    createdAt(state) {
        return state.user.createdAt;
    },
    isLogged(state) {
        return state.user.logged;
    },
};

const mutations = {
    setUser(state, user) {
        state.user = new User(user);
    },
    setLogged(state, logged) {
        state.user.logged = logged;
    },
};

const actions = {
    async checkUserAuthentication({ getters }) {
        if (getters.isLogged === false) {
            Vue.prototype.$toasted.error(i18n.t("Error.unauthorized"), { icon: "times" });
            await router.push("/auth/login");
        }
        return getters.isLogged;
    },
    async getUser({ commit }) {
        const response = await Vue.prototype.$atlasAPI.getUser();
        commit("setUser", new User({ ...response.data, logged: true }));
    },
    async login({ commit, dispatch }, { email, password }) {
        const { data } = await Vue.prototype.$atlasAPI.login({ email, password });
        localStorage.setItem("token", data.token);
        Vue.prototype.$atlasAPI.setToken(data.token);
        await dispatch("getUser");
        commit("setLogged", true);
        Vue.prototype.$toasted.success(i18n.t("Login.loggedIn"), { icon: "check" });
    },
    async logout({ commit }, { toasted = true }) {
        localStorage.removeItem("token");
        Vue.prototype.$atlasAPI.setToken(null);
        if (toasted) {
            Vue.prototype.$toasted.success(i18n.t("Login.loggedOut"), { icon: "lock" });
        }
        await router.push("/auth/login");
        commit("setUser", new User({ logged: false }));
    },
    async checkTokenAndLogin({ commit, dispatch }) {
        const token = localStorage.getItem("token");
        if (token) {
            const decoded = JWT.decode(token);
            const now = Math.round(new Date().getTime() / 1000);
            if (decoded && decoded.exp && now < decoded.exp) {
                Vue.prototype.$atlasAPI.setToken(token);
                return await dispatch("getUser");
            }
        }
        commit("setLogged", false);
        localStorage.removeItem("token");
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};